import React from 'react';
import { Box, Paper, Skeleton, Stack, Typography } from '@mui/material';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';

function StatCard({ icon: Icon, label, value, sub, loading }) {
  return (
    <Paper
      elevation={0}
      sx={{
        flex: 1,
        minWidth: { xs: '100%', sm: 160 },
        p: 2.25,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        transition: 'box-shadow 0.2s, border-color 0.2s',
        '&:hover': {
          borderColor: 'action.hover',
          boxShadow: (t) => t.shadows[2],
        },
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            flexShrink: 0,
          }}
        >
          <Icon sx={{ fontSize: 22 }} />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.06 }}>
            {label}
          </Typography>
          {loading ? (
            <Skeleton variant="text" width={72} height={40} sx={{ mt: 0.5 }} />
          ) : (
            <Typography variant="h5" sx={{ fontWeight: 700, mt: 0.25, lineHeight: 1.2 }}>
              {value}
            </Typography>
          )}
          {sub && !loading ? (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
              {sub}
            </Typography>
          ) : null}
        </Box>
      </Stack>
    </Paper>
  );
}

export default function BatchStatsSummary({ studentCount, batchAvgScore, batchTimelyPct, statsLoading }) {
  const scoreLabel = batchAvgScore != null ? `${batchAvgScore}%` : '—';
  const timelyLabel = batchTimelyPct != null ? `${batchTimelyPct}%` : '—';

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={2}
      sx={{ mb: 3 }}
    >
      <StatCard
        icon={PeopleOutlineIcon}
        label="In batch"
        value={String(studentCount)}
        sub="Students on roster"
        loading={false}
      />
      <StatCard
        icon={TrendingUpIcon}
        label="Avg score"
        value={scoreLabel}
        sub="Mean of roster averages"
        loading={statsLoading && studentCount > 0}
      />
      <StatCard
        icon={ScheduleOutlinedIcon}
        label="On-time rate"
        value={timelyLabel}
        sub="Mean timely completion"
        loading={statsLoading && studentCount > 0}
      />
    </Stack>
  );
}
